module.exports = __webpack_public_path__ + "static/media/exchange-icon.9e5276b7.svg";